<template>
  <div>
    <div ref="xl" :style="{width: '100%', height: '300px'}"></div>
  </div>
</template>

<script>
export default {
  props: {
    xianchind: {
      type: Array,
      default: [],
    },
    timechinner: {
      type: Array,
      default: [],
    },
    lowrlimt: {
      type: Array,
      default: [],
    },
    lowerlimit: {
      type: Array,
      default: [],
    },
    dataMix: {
      type: Array,
      default: [],
    },
    typeunit: {
      type: String,
      default: "",
    },
    dataObjs:{
      type:Object,
      default:{}
    }
  },
  watch: {
    xianchind(val) {
      // console.log(val);
      if (val != "") {
        this.drawLine();
      }
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.xl);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // data: ["最高气温", "最低气温"],
        },
        toolbox: {
          show: true,
        },
              dataZoom: [
          {
            startValue: this.timechinner[0]
          },
          {
            type: "inside",
          },
        ],
        // grid: {
        //   left: "10%",
        //   bottom: "35%",
        // },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.timechinner,
          // axisLabel: {//x轴旋转文字
          //   rotate: 45, //字体倾斜度数
          //   interval: 12, //interval 是指间隔多少个类别画栅格，为 0 时则每个数据都画，为 1 时间隔 1 个画，以此类推
          //   textStyle: {
          //     //  color:"red", //字体颜色
          //     fontSize: 10, //字体大小
          //   },
          // },
        },
        yAxis: {
          type: "value",
            // min:(value)=>{
            //   console.log(value)
            //   return value * 2
            // },
            // scale: true,
                // max:30,
          axisLabel: {
            formatter: "{value}" + this.typeunit,
    
          },
        },
        visualMap: {
          // inverse:true,
          // dataMix
          yAxis: true,
          show: true,
          top: 10,
          right: 0,
          // orient:"vertical",
          //show:false,
          show: true,
          precision: 1,
          pieces: this.dataMix,
        },

        series: [
          {
            // name: "最高气温",
            type: "line",
            smooth: true, //这个是把线变成曲线
            data: this.xianchind,
            markPoint: {
              data: [
                { type: "max", name: "最大值",
                    label: {
                    formatter:  (e)=> {
                      return "Max:" + e.data.value + this.typeunit;
                    },
                  },
                   itemStyle:{
                      color:'red'
                   }
                },
                { type: "min", name: "最小值",
                  label:{
                    formatter:(e)=>{
                      return "Min:" + e.data.value + this.typeunit;
                    }
                  },
                   itemStyle:{
                      color:'blue'
                   }
                },
              ],
            },
            markLine: {
              silent: true,
              data: this.lowrlimt,
                    label: {
                formatter: (e)=>   {
                  // console.log(e);
                  return this.dataObjs.pingjunzhi + e.data.value.toFixed(1) + this.typeunit;
                }
              }
              // data: [{ type: "average", name: "平均值" }],
            },
          },
        
          // {
            // name: "最低气温",
            // type: "line",
            // data: [1, -2, 2, 5, 3, 2, 0],
            // markPoint: {
              // data: [{ name: "周最低", value: -2, xAxis: 1, yAxis: -1.5 }],
            // },
            // markLine: {
            //   silent: true,
            //   // data: this.lowerlimit,
            // },
          // },
        ],
      };

      myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
</style>
